import { Feedback } from "@iunctim/component-feedback/Resources/Public/Scripts/features/Feedback.js";

/**
 * Class to implement the copy-reference functionality
 * as a singleton, which can be instantiated by
 * any other extension as a dependency
 */
export class CopyReference {
    private static instance: CopyReference;

    public static readonly selector = `scope="copy-reference"`;
    public static readonly valueKey = "reference";

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        this.buttons.forEach((button) => this.handle(button));
    }

    /**
     * Method to instantiate all
     * buttons on the current page
     *
     * @returns {CopyReference}
     */
    public static use(): CopyReference {
        if (!CopyReference.instance) {
            CopyReference.instance = new CopyReference();
        }
        return CopyReference.instance;
    }

    /**
     * Selects the buttons
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get buttons(): NodeListOf<HTMLElement> {
        return document.querySelectorAll(`[${CopyReference.selector}]`);
    }

    /**
     * Handles the action on the button
     *
     * @param {HTMLElement} button
     * @returns {void}
     */
    protected handle(button: HTMLElement): void {
        button.addEventListener("click", () => {
            if (button.dataset?.[CopyReference.valueKey]) {
                const value = button.dataset?.[CopyReference.valueKey] ?? "";
                navigator.clipboard.writeText(value).then(() => {
                    Feedback.flash(
                        button,
                        "success",
                        window.translations?.["feedback.copied"] ?? "Copied!",
                    );
                });
            }
        });
    }
}
